import { supabaseClient } from '@/utils/supabase-client';

/**
 * Organizations API functions
 * Pure API calls without React-specific logic
 */

export const organizationsApi = {
  /**
   * Get user's organizations
   */
  getUserOrganizations: (userId: string) => {
    return supabaseClient
      .from('organisation_member')
      .select('organisation(*)')
      .eq('user_id', userId);
  },

  /**
   * Get organisation
   */
  getOrganisation: (tenantId: string) => {
    return supabaseClient
      .from('organisation')
      .select('*')
      .eq('id', tenantId)
      .single();
  },

  getAllOrganisations: () =>
    supabaseClient.from('organisation').select('*, organisation_member(count)'),
} as const;
